<template>
    <on-click-outside :do="close">
        <div class="search-select relative" :class="{ 'is-active': isOpen }">
            <button ref="button" @click="open" type="button" class="search-select-input flex justify-between w-full" :class="{'border-none':noBorder}">
                <span>{{ options[selected].value}}</span>
                <img v-if="showArrowDown" src="@/assets/SVG/Vector.svg" alt="vector-left" class="h-3 w-3" />
            </button>
            <div ref="dropdown" v-show="isOpen" class="search-select-dropdown w-full"
                 :style="selectStyle">
                <ul ref="options" class="search-select-options w-full">
                    <li class="search-select-option w-full"
                        v-for="(option, key) in options"
                        :key="option.id"
                        @click="select(option.id)"
                        :class="{ 'is-active text-white': key === selected }"
                        :style="optionsStyle"
                    >{{ option.value}}</li>
                </ul>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../../OnClickOutside.vue';

export default {
  name: 'CustomSelect',
  components: {
    OnClickOutside,
  },
  props: {
    showArrowDown: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Object,
    },
    options: {},
    value: {
      default: 0,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: 0,
    };
  },
  beforeDestroy() {
    if (this.popper) this.popper.destroy();
  },
  created() {
    if (this.value) {
      const selectedOption = this.options.find(item => item.value === this.value);
      if (selectedOption && selectedOption.id) {
        this.selected = selectedOption.id;
      } else {
        this.selected = 0;
      }
    }
  },
  computed: {
    selectStyle() {
      return {
        '--bg-color-hover': this.colors.bgColorHover,
      };
    },
    optionsStyle() {
      return {
        '--bg-color-selected': this.colors.bgColorSelected,
      };
    },
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
      this.$nextTick(() => {
        this.setupPopper();

        if (this.$refs.search) { this.$refs.search.focus(); }
      });
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
      this.$refs.button.focus();
    },
    select(index) {
      this.selected = index;
      this.$emit('input', this.options[index].value);
      this.close();
    },
  },
};
</script>
<style scoped>
    .search-select {
        position: relative;
    }
    .search-select-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        text-align: left;
        display: block;
        border-width: 1px;
        padding: 0.5rem 0.75rem;
        background-color: #fff;
        border-radius: 4px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border-color: #b4b0c1;
    }
    .search-select-input{
        outline: 0;
    }
    .search-select-placeholder {
        color: #8795a1;
    }
    .search-select.is-active .search-select-input {
        -webkit-box-shadow: 0 0 0 3px rgba(202, 201, 201, 0.3);
        box-shadow: 0 0 0 1px rgba(202, 201, 201, 0.3);
    }
    .search-select-dropdown {
        margin-top: 0.10rem;
        margin-bottom: 0.25rem;
        position: absolute;
        right: 0;
        left: 0;
        background-color: #fff;
        /*padding: 0 0.5rem 0.5rem 0.5rem;*/
        border-radius: 0.25rem;
        -webkit-box-shadow: 0 2px 4px 0 #fff;
        box-shadow: 0 2px 4px 0 #fff;
        z-index: 50;
    }
    .search-select-options {
        list-style: none;
        padding: 0;
        position: relative;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        max-height: 14rem;
        border-width: 1px;
        border-radius: 5px;
        border-color: #979797;
    }
    .search-select-option {
        padding: 0.5rem 0.75rem;
        color: #000000;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .search-select-option:hover {
        background-color: var(--bg-color-hover);
        color:white;
    }
    .search-select-option.is-active,
    .search-select-option.is-active:hover {
        background-color: var(--bg-color-selected);
    }
</style>
